import React from 'react'
import { useTranslation } from 'react-i18next'
import './walletDescription.sass'

const WalletDescription = () => {
    const [t] = useTranslation()
    return (
        <div className={'walletDescription'}>
            <p>{t('Your virtual wallet contains points')}</p>
            <p>{t('You can purchase these points by crediting your virtual wallet by a secure online payment')}</p>
            <p>{t('The points accumulated in your virtual wallet have unlimited validity')}</p>
            <p>{t('You can use these points to offer virtual gifts to any bobVoyeur user by your choice')}</p>
            <p>{t("You can buy points and give virtual gifts even if you're not Premium member")}</p>
        </div>
    )
}

export default WalletDescription
